define('views/modules/template/assignment/manager/per-template/assignment-manager-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/layout',
    // views
    'views/parts/panel/base-panel',
    'views/modules/template/assignment/manager/per-template/assignment-manager-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    LayoutState,
    // views
    VBasePanel,
    VAssignmentManagerContent
) {

    var VPerTemplateAssignmentManagerPanel = VBasePanel.extend({
        content: {
            manager: VAssignmentManagerContent,
        },

        header: {
            title: "Assignments manager",
            subtitle: 'template:Assignments by template'
        },

        tabs: [{ id: 'manager', title: 'Manager', active: true }],
        defaultView: 'manager',

        initialize: function(opt) {
            var manager = this.getView('manager', {
                template: this.model,
                collection: this.collection,
                group: opt.group,
            });
        },

        close: function() {
            LayoutState.toggleInfo(false);
        },

    });

    return VPerTemplateAssignmentManagerPanel;

});

